module.exports = __webpack_public_path__ + "static/media/zwzhome3.1a2dbaa2.jpg";